const ready = (instantiate) => {
  //
  // Turbo links instantiation
  // --------------------------
  if (window['theme']['turbolinksEnabled']) {
    // FE DOM (FREEDOM!)
    document.addEventListener('turbolinks:load', () => {
      if (window.blubolt.turboLinksActive) {
        let loadEvent;
        let onLoadEvent;
        if (typeof (Event) === 'function') {
          loadEvent = new Event('load', {
            bubbles: true,
            cancelable: true
          })
          onLoadEvent = new Event('onLoad', {
            bubbles: true,
            cancelable: true
          })
        } else {
          loadEvent = document.createEvent('Event');
          loadEvent.initEvent('load', true, true);

          onLoadEvent = document.createEvent('Event');
          onLoadEvent.initEvent('onLoad', true, true);
        }
        dispatchEvent(loadEvent);
        dispatchEvent(onLoadEvent);
      }

      window.blubolt.glides = [];
      window.blubolt.turboLinksActive = true

      instantiate(true)
    })

    // 404 handle
    window.addEventListener('blubolt:load', () => instantiate(false));

    //
    // Fall back for turbo links failures
    // -----------------------------------
    document.addEventListener('DOMContentLoaded', () => {
      setTimeout(() => {
        if (!window.blubolt.turboLinksActive) {
          console.error('TurboLinks may have failed, loading fall back')
          instantiate(false)
        }
      }, 3500)
    });
  }

  //
  // No Turbolinks? No problem
  // ---------------------------
  else {
    document.addEventListener('DOMContentLoaded', () => {
      instantiate(false);
    });
  }
}

const onShopifySectionLoad = (run) => {
  //
  // Shopify Event instantiation
  // ----------------------------
  const shopifyEvents = [
    'shopify:section:load'
  ];

  shopifyEvents.forEach((event) => {
    document.addEventListener(event, () => run(event));
  });
}

export {
  ready,
  onShopifySectionLoad
};